/**
 * Stable semantic identifiers for create-service-request wizard steps.
 */
export enum ServiceRequestWizardStepId {
  CUSTOMER_INFO = 'customerInfo',
  SAVED_TEMPLATE = 'savedTemplate',
  SERVICE_TYPE = 'serviceType',
  PICKUP_DROPOFF_TIME = 'pickupDropoffTime',
  ADDITIONAL_INFO = 'additionalInfo',
  ID_INFORMATION = 'idInformation',
  TEAM_MEMBERS = 'teamMembers',
  ORIGIN_LOCATION = 'originLocation',
  DESTINATION = 'destination',
  DROP_OFF_LOCATIONS = 'dropOffLocations',
  SPECIAL_INSTRUCTIONS = 'specialInstructions',
  NOTES_AND_FILES = 'notesAndFiles',
  PREVIEW = 'preview',
}
